export default __webpack_public_path__ + "static/media/zero_stars.d88837db.svg";